// White initials need 4.5:1 on their fill (WCAG 1.4.3). 20 of the original 26
// fills were lighter than that (down to 1.6:1 for "F"), so each was darkened
// along its own hue until it clears 4.6:1; avatarColors.a11y.test.ts holds it.
export function getAvatarColors(character: string) {
  const colorMap: { [key: string]: { bg: string; color: string } } = {
    A: { bg: "#be5605", color: "#fff" },
    B: { bg: "#e2007b", color: "#fff" },
    C: { bg: "#a13ff6", color: "#fff" },
    D: { bg: "#38834c", color: "#fff" },
    E: { bg: "#e12717", color: "#fff" },
    F: { bg: "#956f02", color: "#fff" },
    G: { bg: "#158095", color: "#fff" },
    H: { bg: "#eb0000", color: "#fff" },
    I: { bg: "#1777ca", color: "#fff" },
    J: { bg: "#37833a", color: "#fff" },
    K: { bg: "#d81b60", color: "#fff" },
    L: { bg: "#8e24aa", color: "#fff" },
    M: { bg: "#3949ab", color: "#fff" },
    N: { bg: "#027bb5", color: "#fff" },
    O: { bg: "#008476", color: "#fff" },
    P: { bg: "#d73b0b", color: "#fff" },
    Q: { bg: "#6d4c41", color: "#fff" },
    R: { bg: "#ae6100", color: "#fff" },
    S: { bg: "#587f2f", color: "#fff" },
    T: { bg: "#73791e", color: "#fff" },
    U: { bg: "#008191", color: "#fff" },
    V: { bg: "#5e35b1", color: "#fff" },
    W: { bg: "#e3165b", color: "#fff" },
    X: { bg: "#187f8c", color: "#fff" },
    Y: { bg: "#58802a", color: "#fff" },
    Z: { bg: "#ab47bc", color: "#fff" },
  };

  return colorMap[character.toUpperCase()] || { bg: "#005791ff", color: "#fff" };
}
